module.exports = __webpack_public_path__ + "static/Ae-cde0643eada4203c5dfd3a557eb7aea1.png";